<template>
  <nuttrema-layout-form-standard :edit="true" theme="west-top" :saveError="StuffToEatNutritionFactsPrintLabel.saveError">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData">

        <section>
          <p class="section-title">{{ $t('label.include_on_label') }}</p>
          <div class="section-items">

            <el-form-item>
              <el-col :span="24">
                <el-checkbox v-model="options.product_name">{{ $t('label.product_name') }}</el-checkbox>
              </el-col>

              <el-col :span="24">
                <el-checkbox v-model="options.nutrition_facts">{{ $t('label.nutrition_facts') }}</el-checkbox>
              </el-col>

              <el-col :span="24">
                <el-checkbox v-model="options.ingredients">{{ $t('label.ingredients') }}</el-checkbox>
              </el-col>

              <el-col :span="24">
                <permissions-control-wrapper
                   tooltipPlacement="bottom"
                   action="permissions.subscribed_plan.food_allergens"
                  :permissions="permissions"
                  :required-general="$PERMISSIONS_GENERAL.DOWNLOAD"
                  :required-subscribed-plan="$PERMISSIONS_SUBSCRIBED_PLAN.FOOD_ALLERGENS">
                  <el-checkbox slot="allowed" v-model="options.allergens">{{ $t('label.allergen_information') }}</el-checkbox>
                  <div slot="not-allowed">
                    <el-checkbox v-model="options.allergens" disabled>{{ $t('label.allergen_information') }}</el-checkbox>
                  </div>
                </permissions-control-wrapper>
              </el-col>

              <el-col :span="24">
                <el-checkbox v-model="options.custom_text">{{ $t('label.custom_text') }}</el-checkbox>
              </el-col>

              <el-col v-if="options.custom_text" :span="24">
                <nuttrema-medium-editor v-model="formData.custom_text" :edit="true" hint-label="label.you_can_use_html_labels"></nuttrema-medium-editor>
              </el-col>

            </el-form-item>
          </div>

        </section>

        <section>
          <p class="section-title">{{ $t('label.label_length') }}</p>
          <div class="section-items">
            <el-form-item>
              <el-col :span="24">
                <el-checkbox v-model="options.label_length_automatic">{{ $t('label.automatic') }}</el-checkbox>
              </el-col>
            </el-form-item>
            <el-form-item v-if="!options.label_length_automatic" :label="$t('label.custom_label_length')" prop="custom_label_length">
              <el-col :span="16">
                <el-input-number size="small" :min="10" :max="1000" v-model="formData.label_length_mm"></el-input-number>
              </el-col>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-dropdown @command="handleDownload">
          <el-button
            size="small"
            class="w-100"
            type="primary"
            icon="far fa-download"
            :plain="true"
            :disabled="!isValid"
            :loading="formData.action === 'download' && StuffToEatNutritionFactsPrintLabel.fetching">
            Download <i class="el-icon-arrow-up el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="pdf">PDF</el-dropdown-item>
            <el-dropdown-item command="xlsx">Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- <el-button
           size="small"
           class="w-40"
           type="primary"
           icon="far fa-download"
          :plain="true"
          :disabled="!isValid"
          :loading="formData.action === 'download' && StuffToEatNutritionFactsPrintLabel.fetching"
          @click="handleDownload">
          {{ $t('label.download_as_pdf') }}
        </el-button> -->

        <el-button
           size="small"
           class="w-40"
           type="primary"
           icon="far fa-print"
          :plain="true"
          :disabled="!isValid"
          :loading="formData.action === 'print' && StuffToEatNutritionFactsPrintLabel.fetching"
          @click="handlePrint">
          {{ $t('label.print') }}
        </el-button>
      </nav>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { join } from 'lodash';
import NuttremaMediumEditor from 'components/ui/editor/nuttrema-medium-editor';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-labels-popover',
  componentName: 'FormLabelsPopover',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    StuffToEatNutritionFactsPrintLabel: {
      required: true,
      default: null,
    },
    permissions: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaMediumEditor,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        action: null,
        custom_text: null,
        label_length_mm: 80,
        file_format: undefined,
      },
      options: {
        allergens: false,
        ingredients: false,
        custom_text: false,
        product_name: false,
        nutrition_facts: true,
        label_length_automatic: true,
      },
    };
  },
  computed: {
    isValid() {
      return this.options.product_name || this.options.nutrition_facts ||
      this.options.ingredients || this.options.allergens ||
      (this.options.custom_text && this.formData.custom_text && this.formData.custom_text !== '');
    },
  },
  methods: {
    handleDownload(fileFormat) {
      console.log('handleDownload', fileFormat);
      this.formData.action = 'download';
      this.formData.file_format = fileFormat;
      this.submitForm(false);
    },
    handlePrint() {
      this.formData.action = 'print';
      this.formData.file_format = 'pdf';
      this.submitForm(false);
    },
    getFormData() {
      const options = [];

      if (this.options.product_name) options.push('product_name');
      if (this.options.nutrition_facts) options.push('nutrition_facts');
      if (this.options.ingredients) options.push('ingredients');
      if (this.options.allergens) options.push('allergen_info');
      if (this.options.custom_text) options.push('custom_text');

      return {
        action: this.formData.action,
        query: {
          options: join(options, ','),
          label_length_mm: !this.options.label_length_automatic ? this.formData.label_length_mm : null,
          custom_text: this.options.custom_text ? this.formData.custom_text : null,
          file_format: this.formData.file_format || undefined,
        },
      };
    },
  },
  created() {
    this.stateData = this.StuffToEatNutritionFactsPrintLabel;
    this.formRef = 'form-label-popover';
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/labels/form-labels-popover.vue